import businessSupport from './businessSupport.module.scss';
import careerSupport from './careerSupport.module.scss';
import development from './development.module.scss';
import marketing from './marketing.module.scss';
import product from './product.module.scss';
import sales from './sales.module.scss';

export { businessSupport, development, marketing, product, sales, careerSupport };
